<div class="support-ticket-container">
  <!-- Contenuto scrollabile -->
  <div class="form-content">
    <form [formGroup]="ticketForm">
      <!-- Nome ed Email sulla stessa riga -->
      <div class="form-row">
        <!-- Nome -->
        <div class="form-field">
          <label for="name" class="form-label">
            Nome <span class="required">*</span>
          </label>
          <input
            id="name"
            type="text"
            pInputText
            formControlName="name"
            placeholder="Il tuo nome completo"
            class="w-full"
            [class.p-invalid]="name?.invalid && name?.touched"
          />
          <small class="p-error" *ngIf="name?.invalid && name?.touched">
            <span *ngIf="name?.errors?.['required']">Il nome è obbligatorio</span>
          </small>
        </div>

        <!-- Email -->
        <div class="form-field">
          <label for="email" class="form-label">
            Email <span class="required">*</span>
          </label>
          <input
            id="email"
            type="email"
            pInputText
            formControlName="email"
            placeholder="la.tua@email.it"
            class="w-full"
            [class.p-invalid]="email?.invalid && email?.touched"
          />
          <small class="p-error" *ngIf="email?.invalid && email?.touched">
            <span *ngIf="email?.errors?.['required']">L'email è obbligatoria</span>
            <span *ngIf="email?.errors?.['email']">Inserisci un'email valida</span>
          </small>
        </div>
      </div>

      <!-- Oggetto -->
      <div class="form-field">
        <label for="subject" class="form-label">
          Oggetto <span class="required">*</span>
        </label>
        <input
          id="subject"
          type="text"
          pInputText
          formControlName="subject"
          placeholder="Oggetto della richiesta"
          class="w-full"
          [class.p-invalid]="subject?.invalid && subject?.touched"
        />
        <small class="p-error" *ngIf="subject?.invalid && subject?.touched">
          <span *ngIf="subject?.errors?.['required']">L'oggetto è obbligatorio</span>
          <span *ngIf="subject?.errors?.['minlength']">L'oggetto deve contenere almeno 3 caratteri</span>
        </small>
      </div>

      <!-- Messaggio -->
      <div class="form-field">
        <label for="message" class="form-label">
          Messaggio <span class="required">*</span>
        </label>
        <textarea
          id="message"
          pInputTextarea
          formControlName="message"
          placeholder="Descrivi qui la tua richiesta di supporto..."
          rows="7"
          class="w-full"
          [class.p-invalid]="message?.invalid && message?.touched"
        ></textarea>
        <small class="p-error" *ngIf="message?.invalid && message?.touched">
          <span *ngIf="message?.errors?.['required']">Il messaggio è obbligatorio</span>
          <span *ngIf="message?.errors?.['minlength']">Il messaggio deve contenere almeno 10 caratteri</span>
        </small>
      </div>

    <!-- Upload Allegati -->
    <div class="form-field">
      <label class="form-label">Allegati (opzionale)</label>
      <p-fileUpload
        #fileUpload
        mode="advanced"
        [multiple]="true"
        [maxFileSize]="10000000"
        accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
        [showUploadButton]="false"
        [showCancelButton]="false"
        [customUpload]="true"
        (onSelect)="onFileSelect($event)"
        (onRemove)="onFileRemove($event)"
        chooseLabel="Seleziona file"
        chooseIcon="pi pi-paperclip"
        styleClass="custom-file-upload"
      >
        <ng-template pTemplate="content">
          <div class="upload-hint" *ngIf="uploadedFiles.length === 0" (click)="openFileDialog()" style="cursor: pointer;">
            <i class="pi pi-cloud-upload" style="font-size: 2rem; color: var(--primary-color);"></i>
            <p><strong>Clicca qui</strong> per selezionare i file o trascinali in quest'area</p>
            <small>Dimensione massima: 10MB per file - Puoi caricare più file contemporaneamente</small>
          </div>
        </ng-template>
      </p-fileUpload>
    </div>
    </form>
  </div>

  <!-- Footer Fisso -->
  <div class="fixed-footer">
    <button
      pButton
      type="button"
      label="Annulla"
      icon="pi pi-times"
      class="p-button-text p-button-secondary"
      (click)="onCancel()"
      [disabled]="isSubmitting"
    ></button>
    <button
      pButton
      type="button"
      label="Invia Richiesta"
      icon="pi pi-send"
      class="p-button-success"
      [loading]="isSubmitting"
      [disabled]="ticketForm.invalid"
      (click)="onSubmit()"
    ></button>
  </div>
</div>
